module.exports = __webpack_public_path__ + "img/jenkins.801b5ceb.svg";